import { ServiceMaker, methods, services } from "../services";
import Api from "@/services/service-v2";

export const listOfItem = () =>
  ServiceMaker(
    `/api/catalog/write/catalog/item`,
    methods.GET,
    services.catalog
  );

export const itemFindByOption = (condition) =>
  ServiceMaker(
    `/api/catalog/read/catalog/item/by?page=1&limit=count`,
    methods.POST,
    services.catalog,
    condition
  );

export const getById = (id) =>
  ServiceMaker(
    `/api/catalog/read/catalog/item/${id}`,
    methods.GET,
    services.catalog
  );

export const updateById = (id, doc) =>
  ServiceMaker(`/api/item/${id}`, methods.PUT, services.catalog, doc);
export const createItem = (data) =>
  ServiceMaker("/api/item", methods.POST, services.catalog, data);
export const getTenantItemsCount = () =>
  ServiceMaker(`/api/item/details/count`, methods.GET, services.catalog);

export const downloadItemTemplate = (Id) =>
  ServiceMaker(
    `/api/catalog/read/item-template-csv-export/${Id}`,
    methods.GET,
    services.catalog,
    null,
    true
  );

export const bulkItemImport = (payload) =>
  ServiceMaker(`/bulk-item-import`, methods.POST, services.bulkimport, payload);

export const getBulkReport = (payload) =>
  ServiceMaker(
    `bulk-item-import/list?status=${payload.status}&days=${payload.days}`,
    methods.GET,
    services.bulkimport
  );

export const getItemDetailsById = (payload) =>
  ServiceMaker(`/catalog/api/item/${payload}`, methods.GET, services.master);

export const offlineItem = (payload) =>
  Api().$http.post(`catalog/api/item/offline`, payload);

export const listDriver = (payload) =>
  Api().$http.get(`cap/users/admin/list?userType=DRIVER`, payload);
